module.exports = __webpack_public_path__ + "img/Xgrow-5-es.71e3dfbb.png";